import React from "react";
import { useTrans } from "@/utils/useTrans";
import Image from "next/image";
import { cn } from "@/libs/utils";

interface SupportBannerImgSectionProps {
  bannerImg: string;
  mobileBannerImg: string;
  bannerTitle: string;
  isTitleShadow?: boolean;
}
/*
 support banner section
 */
const SupportBannerImgSection = ({
  bannerImg,
  mobileBannerImg,
  bannerTitle,
  isTitleShadow = false,
}: SupportBannerImgSectionProps) => {
  const { t } = useTrans(["support"]);

  return (
    <figure className="relative flex h-[120px] w-full items-center justify-center smd:h-[200px]">
      <Image
        src={bannerImg}
        width={1920}
        height={200}
        quality={90}
        alt={"support-banner"}
        className={
          "hidden max-h-[200px] min-h-[200px] w-full object-cover smd:block"
        }
        priority
      />
      <Image
        src={mobileBannerImg}
        alt={"support-mobile-banner"}
        className={"object-cover smd:hidden"}
        fill
        priority
      />
      <h1
        className={cn(
          "absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transform text-center text-2xl text-white smd:text-5xl",
          { "[text-shadow:_0_1px_0_rgb(0_0_0_/_40%)]": isTitleShadow },
        )}
      >
        {t(bannerTitle)}
      </h1>
    </figure>
  );
};

export default SupportBannerImgSection;
